import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import * as localStorageLib from "../lib/localStorage";
import { matchUrl } from "../lib/urlMatcher";
export interface VisitedUrlsParams {
    id: string;
    urls: string;
    count: number;
    delayInSeconds: number;
}

const localStoragePrefix = "visitedUrls";
export class VisitedUrls implements Trigger {
    params: VisitedUrlsParams;
    constructor(params: VisitedUrlsParams) {
        this.params = params;
    }
    init = (action: Action) => {
        let currentPath = location.pathname;
        let urls = this.params.urls.split(",");

        let isMatch = matchUrl(urls, currentPath);
        if (isMatch) {
            let setCount = localStorageLib.getItem(localStoragePrefix, this.params.id) as number;
            if (setCount == null || undefined) {
                setCount = 0;
            }
            if (setCount === -1) return;

            setCount++;

            if (setCount >= this.params.count) {
                setCount = 0;
                setTimeout(
                    () => {
                        action.execute();
                    },
                    (this.params.delayInSeconds || 0) * 1000,
                );
            }
            localStorageLib.setItem(localStoragePrefix, this.params.id, setCount);
        }
    };
}
